import React from 'react';
import { 
  Upload, 
  ClipboardCheck, 
  CreditCard,
  UserCheck,
  Mail,
  FileCheck,
  ArrowRight
} from 'lucide-react';

// Icon size and color to match your design
const ICON_SIZE = 48;
const ICON_COLOR = "#e91e63"; // Pink/red color used in your examples

// Map icon numbers to Lucide components
const iconMap = {
  '1': <Upload size={ICON_SIZE} color={ICON_COLOR} />,
  '2': <ClipboardCheck size={ICON_SIZE} color={ICON_COLOR} />,
  '3': <CreditCard size={ICON_SIZE} color={ICON_COLOR} />,
  '4': <UserCheck size={ICON_SIZE} color={ICON_COLOR} />,
  '5': <Mail size={ICON_SIZE} color={ICON_COLOR} />,
  '6': <FileCheck size={ICON_SIZE} color={ICON_COLOR} />
};

const HowItWorksItem = ({ icon, title, description, moveIcon }) => {
   return (
      <>
         <div className={`col-lg-3 col-md-3 ${moveIcon && 'pos-rel'}`}>
            <div className="howit-box text-center mb-40">
               <i className="lucide-icon-container">
                  {iconMap[icon] || <img src={`img/sicknote/how/icon-${icon}.png`} alt=""/>}
               </i>
               <h3>{title}</h3>
               <p>{description}</p>
            </div>
         </div>
         {moveIcon &&
         <div className="col-lg-1 col-md-1 move-icon" style={{ marginTop: '100px' }}>
            <ArrowRight size={24} color={ICON_COLOR} strokeWidth={2} />
         </div>
         }
      </>
   );
};

export default HowItWorksItem;